import { useHistory } from "react-router";

import buttoncss from "./../../css/button.module.css";
import commoncss from "./../../css/common.module.css";
import Modal from "./../../elements/Modal";
import { Button } from "./../../elements/Button";
import Dropdown from "./../../elements/Dropdown";
import InputGroup from "./../../elements/InputGroup";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

const ReferenceModal = ({ setViewReferenceModal, modalData }) => {
  const header = modalData;
  const libRefList = [];
  const history = useHistory();

  return (
    <Modal
      title={header}
      width="30%"
      headerActions={
        <CloseIcon
          onClick={() => {
            setViewReferenceModal(false);
          }}
          className="clickable"
        />
      }
      // footerActions={
      //   <> If it is not dont by 14 Dec, you are not going to institue
      //     <Button
      //       btnColor={buttoncss.secondary}
      //       onClick={() => {
      //         setViewReferenceModal(false);
      //       }}
      //       label="Close"
      //     />
      //   </>
      // }
      onClose={() => console.log("Modal Closed")}
    >
      <div
        className={commoncss.dFlex}
        style={{ "justify-content": "space-evenly" }}
      >
        <Button
          btnColor={buttoncss.primary}
          onClick={() => {
            history.push("/library-indas-1");
          }}
          label="IND AS References"
        />
        <Button
          btnColor={buttoncss.primary}
          onClick={() => {}}
          label="Checklist References"
        />
      </div>
    </Modal>
  );
};

export default ReferenceModal;